import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "relative datepicker-container" }
const _hoisted_2 = {
  key: 0,
  class: "input-label mb-3"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "text-error" }, "*", -1)
const _hoisted_4 = {
  key: 1,
  class: "input-label mb-3"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "text-error" }, "*", -1)
const _hoisted_6 = {
  key: 0,
  class: "text-[15px] font-semibold capitalize"
}
const _hoisted_7 = {
  key: 1,
  class: "text-[13px] font-normal text-textMedium"
}
const _hoisted_8 = { class: "absolute right-5 top-1/2 -translate-y-1/2" }
const _hoisted_9 = {
  key: 2,
  class: "error-message"
}
const _hoisted_10 = {
  key: 3,
  class: "error-message"
}
const _hoisted_11 = { class: "flex flex-col md:flex-row items-start justify-between" }
const _hoisted_12 = {
  key: 0,
  class: "w-full md:max-w-[332px]"
}
const _hoisted_13 = { class: "w-full mt-10 md:mt-0 max-w-[568px]" }

import CalendarModal from './components/CalendarModal.vue';
import CalendarIcon from './components/CalendarIcon.vue';
import PickADoctor from './components/PickADoctor.vue';
import { ref, onMounted } from 'vue';
import { useToggleModal } from './hooks/useToggleModal.js';
import { useField } from 'vee-validate';
import Calendar from './components/Calendar/Calendar.vue';
import { outputDateFormat } from '../../../helpers/formatDate.js';
import axios from 'axios';
import { transformDoctorsData, processData } from './helpers/dataProcessing.js';


export default {
  __name: 'CalendarSection',
  props: {
    productId: {
        type: Number,
    },
    withoutDoctors: {
        type: Boolean,
        default: false,
    },
},
  setup(__props) {

const props = __props;



const { axis, isOpen, toggleModal, input } = useToggleModal();

const { value: selectedDoctorValue, errorMessage: selectedDoctorErrorMsg } =
    useField('selectedDoctor');

const { value: selectedCallDateValue, errorMessage: selectedCallDateErrorMsg } = useField(
    'selectedConsultationDate',
);

const scheduleStatus = ref('idle');
const doctorsStatus = ref('idle');
const doctors = ref({});

const schedule = ref({});

const setSchedule = (value) => (schedule.value = value);

const setStatus = (value) => (scheduleStatus.value = value);

onMounted(() => {
    if (props.withoutDoctors) {
        setStatus('loading');

        const data = new FormData();
        data.append('action', 'wizyta_terminy');
        data.append('prod', props.productId);

        axios.post(jsData.ajaxUrl, data).then(({ data }) => {
            if (data.success) {
                setStatus('success');
                setSchedule(processData(data.data));
            }
        });
    } else {
        doctorsStatus.value = 'loading';
        const data = new FormData();
        data.append('action', 'wizyta_lekarze');
        data.append('prod', props.productId);

        axios.post(jsData.ajaxUrl, data).then(({ data }) => {
            if (data.success) {
                doctorsStatus.value = 'success';
                doctors.value = transformDoctorsData(data.data);
            }
        });
    }
});

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!__props.withoutDoctors)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
          _createTextVNode("Wybierz dogodny termin i Iekаrza "),
          _hoisted_3
        ]))
      : _createCommentVNode("", true),
    (__props.withoutDoctors)
      ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
          _createTextVNode("Wybierz dogodny termin "),
          _hoisted_5
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      ref_key: "input",
      ref: input,
      onClick: _cache[0] || (_cache[0] = (...args) => (_unref(toggleModal) && _unref(toggleModal)(...args))),
      class: "cursor-pointer rounded-lg px-4 py-[13px] bg-light flex flex-col items-start justify-center min-w-[332px] h-[64px] relative"
    }, [
      (_unref(selectedCallDateValue))
        ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_unref(outputDateFormat)(_unref(selectedCallDateValue).date)) + ", " + _toDisplayString(_unref(selectedCallDateValue).hour), 1))
        : _createCommentVNode("", true),
      (_unref(selectedDoctorValue))
        ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_unref(selectedDoctorValue).title), 1))
        : _createCommentVNode("", true),
      _createElementVNode("span", _hoisted_8, [
        _createVNode(CalendarIcon)
      ])
    ], 512),
    (_unref(selectedCallDateErrorMsg))
      ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(_unref(selectedCallDateErrorMsg)), 1))
      : _createCommentVNode("", true),
    (_unref(selectedDoctorErrorMsg))
      ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(_unref(selectedDoctorErrorMsg)), 1))
      : _createCommentVNode("", true),
    _createVNode(CalendarModal, {
      isOpen: _unref(isOpen),
      position: _unref(axis),
      onClose: _unref(toggleModal),
      withoutDoctors: __props.withoutDoctors
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_11, [
          (!__props.withoutDoctors)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createVNode(PickADoctor, {
                  doctors: doctors.value,
                  doctorsStatus: doctorsStatus.value,
                  productId: __props.productId,
                  setStatus: setStatus,
                  setSchedule: setSchedule
                }, null, 8, ["doctors", "doctorsStatus", "productId"])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_13, [
            _createVNode(Calendar, {
              toggleModal: _unref(toggleModal),
              status: scheduleStatus.value,
              schedule: schedule.value
            }, null, 8, ["toggleModal", "status", "schedule"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["isOpen", "position", "onClose", "withoutDoctors"])
  ]))
}
}

}